import {  Box, Button, TextField, Typography, useTheme, Grid , InputBase, styled} from "@mui/material";
import { tokens } from "../../theme";
import * as yup from "yup";
import axios from "axios";
import Snackbar from '@mui/material/Snackbar';
import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { apiLogin } from "./apiService/index.js";
import { execApi,API_ENDPOINT_URL } from "../../util/api";
import { getLocalItem,removeLocalItem } from "../../util/helper";
import CircularProgress from '@mui/material/CircularProgress';
import { useContextAuthentication } from "../../util/useContextAuth.js";

// Helper function to get cookie by name
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}  


const Login = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [validate, setValidate] = useState(false);
  const [emailOrUsername, setUserNameOrEmail] = useState("");
  const [password, setPassword] = useState("");

  const [state, setState] = useState({
    open: false,
    vertical: 'top',
    horizontal: 'right',
    mess:"Login success",
    background:"#2e7d31"
  });
  const { vertical, horizontal, open, mess, background} = state;

  const contextAuth = useContextAuthentication();

  const handleChangeUsernameOrEmail =(value)=>{
    setUserNameOrEmail(value);
  }

  const handleChangePassword=(value)=>{
    setPassword(value);

  }

  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const handleNotification = (mess, background) =>{
    setState({ ...state, mess, background, open:true});

  }

  const handleEnter =(event)=>{
    if(event.key === "Enter") { 
      handleFormSubmit()
    }
  }

  const handleFormSubmit = async () => {
      if (emailOrUsername && password) {

        const requestData = {};
        if (emailOrUsername.includes("@")) {
            requestData.email = emailOrUsername;
        } else {
            requestData.username = emailOrUsername;
        }
        requestData.password = password;
        setLoading(true);
        axios
          .post(`${API_ENDPOINT_URL}/login/`, requestData, { headers: {} })
          .then(response => {
              handleNotification("Login success","#2e7d31")
              const key = response.data.key;
              const is_superuser = response.data?.is_superuser;
              const is_staff = response.data?.is_staff;
              localStorage.setItem('key', key); // Store token in local storage
              localStorage.setItem('is_superuser', is_superuser);
              localStorage.setItem('is_staff', is_staff);
              const isAdmin = !!(is_superuser && is_staff);
              contextAuth.setValueContext({ isAdmin, key })
              setLoading(false);
              setTimeout(() => { 
                navigate('/url-lookup')
              }, 500)

          })
          .catch(error => {
            setLoading(false);
            handleNotification("Wrong email or password","#D2302F")
            console.log(error);
          });
      } else {
        setValidate(true);
      }
    };

  return (
    <Box
      display="flex"
      height="100vh"
      textAlign="center"
      alignItems="center"
      justifyContent="center"
      width="100%"
    >
       <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        message={mess}
        onClose={handleClose}
        key={vertical + horizontal}
        sx={{"& .MuiSnackbarContent-root": {
          backgroundColor: background,
          color:"white",
          fontWeight:"bold"
        } }}
        autoHideDuration={600}
      />
      <Box
        sx={{
          width: "100%",
          height: 500,
        }}
      >
        <Grid container spacing={10}>
          <Grid item xs={12} sm={7} md={7} lg={8} textAlign="right">
            <Box mt={5} >
                <Typography variant="h1" fontSize={45} fontWeight="bold" color="#2699fb">
                  PhishDetector
                </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={5} md={5} lg={4} textAlign="left">
            <Box mt={2}>
                <Box>
                    <Typography variant="h6" fontSize={15} fontWeight="bold" color="#2699fb">
                        Username or email
                    </Typography>
                    <InputBase placeholder="email" 
                        sx={{
                            marginTop:"5px",
                            backgroundColor:"#f1f9ff",
                            width:"50%",
                            border:"2px solid #bce0fd",
                            borderRadius:"10px",
                            color:"#2699fb",
                            padding: "8px 15px 8px 15px",
                         }}
                         onChange={(event)=>handleChangeUsernameOrEmail(event.target.value)}
                         onKeyPress={handleEnter}

                    />
                </Box>
                <Box height="16px" width="100%" alignItems="center" color="red">{(validate && !emailOrUsername)?"Username or email not be blank!":""}</Box>

                <Box mt={1}>
                    <Typography variant="h6" fontSize={15} fontWeight="bold" color="#2699fb">
                    Password
                    </Typography>
                    <InputBase placeholder="password" type="password"
                         sx={{
                            marginTop:"5px",
                            backgroundColor:"#f1f9ff",
                            width:"50%",
                            border:"2px solid #bce0fd",
                            borderRadius:"10px",
                            color:"#2699fb",
                            padding: "8px 15px 8px 15px",
                         }}
                         onChange={(event)=>handleChangePassword(event.target.value)}
                         onKeyPress={handleEnter}

                    />

                </Box>

                <Box height="16px" width="100%" alignItems="center" color="red">{(validate && !password)?"Password not be blank!":""}</Box>
                
                <Box 
            mt={5} 
            padding="14px"            
            onClick={handleFormSubmit}
            sx={{
                backgroundColor: "#2699fb",
                color: "white",
                borderRadius: "4px", 
                '&:hover': {
                    cursor: 'pointer'
                },
                width: "50%",
                display: 'flex',
                alignItems: 'center',
                position: 'relative'
            }}
        >
            <Typography variant="body1" m={0} sx={{ flexGrow: 1, textAlign: 'center' }}>
                Login
            </Typography>
            
            {loading ? (
              <CircularProgress 
                size={24} 
                sx={{ 
                    position: 'absolute', 
                    color: 'white',
                    right: 20
                }} 
              />
            ) : (null)}
            
        </Box>

            </Box>
          </Grid>
          <Grid item xs={0} sm={0} md={0} lg={1}>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  username: yup.string().required("Username or email not be blank"),
  password: yup.string().required("Password not be blank")
});
const initialValues = {
  username: "",
  password: "",
};

export default Login;
